import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import * as React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

// import { FullPageError } from 'components/FullPageError';
import { FullPageSpinner } from 'components/FullPageSpinner';
import { MaintenanceScreen } from 'components/MaintenanceScreen';
import { ErrorBoundary } from 'error/ErrorBoundary';
import { useUnderMaintenanceConfig } from 'hooks/useFirebaseRemoteConfig';
import { ApolloWrapper } from 'lib/apollo';
import { store } from 'lib/store';
import { theme } from 'theme';

import { PusherProvider } from '@/contexts/PusherContext';

import 'utils/mixpanel/initializeMixpanel';

type AppProviderProps = {
  children: React.ReactNode;
};

const AppContent = ({ children }: AppProviderProps) => {
  const { underMaintenance, loading, initialize } = useUnderMaintenanceConfig();

  // Initialize Firebase Remote Config on mount
  React.useEffect(() => {
    initialize();
  }, [initialize]);

  // Show spinner while loading the config
  if (loading) {
    return <FullPageSpinner />;
  }

  // Show maintenance screen if enabled
  if (underMaintenance?.is_enabled) {
    return <MaintenanceScreen />;
  }

  // Show normal app
  return (
    <ErrorBoundary>
      <ApolloWrapper>
        <PusherProvider>
          <Router>{children}</Router>
        </PusherProvider>
      </ApolloWrapper>
    </ErrorBoundary>
  );
};

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <Provider store={store}>
      <React.Suspense fallback={<FullPageSpinner />}>
        <ColorModeScript initialColorMode={theme.config.initialColorMode} />
        <ChakraProvider theme={theme}>
          {/* <Sentry.ErrorBoundary fallback={<FullPageError />}> */}
          <AppContent>{children}</AppContent>
          {/* </Sentry.ErrorBoundary> */}
        </ChakraProvider>
      </React.Suspense>
    </Provider>
  );
};
